import React from 'react';

import { IQuickStartGuideBoxFields } from '../../../types/contentful';

import { Text } from '../Text';
import RichText from '../RichText';
import { Box } from '../Box';

import { Image, TextWrapper } from './styles';

export function QuickStartGuideBox({
  image,
  header,
  text
}: IQuickStartGuideBoxFields) {
  const { file, description } = image?.fields ?? {};

  return (
    <Box
      padding={{ 0: ['m', 'xs'], tablet: ['l', 'm'] }}
      data-testid="quick-start-box"
    >
      {file && (
        <Image
          src={file?.url ?? undefined}
          alt={description ?? ''}
          loading="lazy"
        />
      )}
      <TextWrapper
        backgroundColor="pressPostBg"
        borderRadius={{
          0: ['0', '0', 'pressPost', 'pressPost']
        }}
        padding={{
          0: ['2xl', 'l', 'xl', 'l'],
          tablet: ['quickStartGuideTop', 'xl', 'xl', 'xl']
        }}
      >
        <Box paddingBottom="sm">
          <Text
            as="h3"
            fontWeight="h3"
            fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
          >
            {header}
          </Text>
        </Box>
        {text && <RichText data={text} />}
      </TextWrapper>
    </Box>
  );
}
